import React from 'react';
import {
  ReviewsSection,
  Container,
  ReviewsHeader,
  ReviewsTitle,
  ReviewsSubtitle,
  ReviewsContent,
  GoogleMapsLink,
  MapsButton,
  WriteReviewButton
} from './GoogleReviews.styles.jsx';

const GOOGLE_MAPS_URL = process.env.REACT_APP_GOOGLE_MAPS_URL || '';
const GOOGLE_PLACE_ID = process.env.REACT_APP_GOOGLE_PLACE_ID || '';

const GoogleReviews = () => {
  const getMapsLink = () => {
    if (GOOGLE_MAPS_URL) {
      return GOOGLE_MAPS_URL;
    }
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent('Instalații Pro')}`;
  };

  const getReviewLink = () => {
    if (!GOOGLE_PLACE_ID) return '#';
    return `https://search.google.com/local/writereview?placeid=${GOOGLE_PLACE_ID}`;
  };

  return (
    <ReviewsSection>
      <Container>
        <ReviewsHeader>
          <ReviewsTitle>Recenzii Google</ReviewsTitle>
          <ReviewsSubtitle>
            Vezi ce spun clienții noștri despre serviciile noastre
          </ReviewsSubtitle>
        </ReviewsHeader>

        <ReviewsContent>
          <GoogleMapsLink>
            <MapsButton
              href={getMapsLink()}
              target="_blank"
              rel="noopener noreferrer"
            >
              📍 Vezi pe Google Maps
            </MapsButton>
            <WriteReviewButton
              href={getReviewLink()}
              target="_blank"
              rel="noopener noreferrer"
            >
              ✍️ Scrie o Recenzie
            </WriteReviewButton>
          </GoogleMapsLink>
        </ReviewsContent>
      </Container>
    </ReviewsSection>
  );
};

export default GoogleReviews;
